import React from 'react'
import LoadComposition from './loadComposition';

const LoadCompositionIndex = () => (
  <LoadComposition />
)

export default LoadCompositionIndex;
